import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoSection from 'eco-design/base/eco-section';
import { FC } from 'react';
import Brands from '../Brands';
import MinTitle from '../MinTitle';
import styled from './index.module.scss';

interface SeamLessProps {
    pageType: string;
}
const euPages = ['normal', 'ultra', 'ac'];

const SeamLess: FC<SeamLessProps> = ({ pageType = 'normal' }) => {
    const { locale } = getLocal();
    const { t } = useLang('theProduct.SeamLess');

    return (
        <section id="SeamLess" className={`${styled.SeamLess} GtmModuleData-section`} data-section-id="SeamLess" data-section-title={t('seamLess_title')}>
            <div className="seamLess-box-title">
                {/* {euPages.includes(pageType) && <MinTitle title={t('save_smart')} align="center" />} */}

                <EcoSection subTitle={t('seamLess_subtitle')} title={t('seamLess_title')} className="product-section" subTitleColor="#83868D" />
            </div>

            <Brands></Brands>
        </section>
    );
};

export default SeamLess;
